import { useCallback } from "react";
import { MDSIconKind } from "@/mds";
import { isMac } from "@/domains/platform/isMac";
import { MDSIconButton } from "@/mds";
import { clientEnvModule } from "@/modules/client-env";
import { electronModule } from "@/modules/electron";
import styled from "@emotion/styled";

export const TopBarDesktopSection = () => {
  const isDesktop = clientEnvModule.isDesktop();
  const isMacOS = isMac();

  // Window control handlers for desktop app (Electron)
  const handleMinimizeWindow = useCallback(() => {
    electronModule.minimizeWindow();
  }, []);

  const handleMaximizeWindow = useCallback(() => {
    electronModule.maximizeWindow();
  }, []);

  const handleCloseWindow = useCallback(() => {
    electronModule.closeWindow();
  }, []);

  if (!isDesktop || isMacOS) return null;
  return (
    <WindowControls>
      <MDSIconButton iconKind={MDSIconKind.WindowMinimize} onClick={handleMinimizeWindow} />
      <MDSIconButton iconKind={MDSIconKind.Square} onClick={handleMaximizeWindow} />
      <CloseButton iconKind={MDSIconKind.Exit} onClick={handleCloseWindow} />
    </WindowControls>
  );
};

const WindowControls = styled.div(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "row",
  borderLeft: `1px solid ${theme.colors.border.default}`,
  padding: theme.spacing["2"],
}));

// Styled close button with Windows-style hover effect
const CloseButton = styled(MDSIconButton)(({ theme }) => ({
  "&[data-hovered]:not([data-disabled])": {
    backgroundColor: "#C42B1C", // Windows 11 style
    transition: "all 0.1s ease-in-out",
    svg: {
      color: theme.colors.paper,
    },
  },
}));
